import React from 'react';
import { Box, Typography } from '@mui/material';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';

const NoRecordFound = ({ 
  title = "No Record Found", 
  message = "Try updating your filters or search criteria to find what you're looking for.",
  icon: Icon = SentimentDissatisfiedIcon
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 6,
        backgroundColor: 'white',
        borderRadius: 2,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        textAlign: 'center',
        width: '100%',
        mb: 3
      }}
    >
      <Icon 
        sx={{ 
          fontSize: 64, 
          color: '#536DFE', 
          opacity: 0.8,
          mb: 2 
        }} 
      />
      <Typography variant="h5" sx={{ fontWeight: 700, color: '#000', mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 450 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default NoRecordFound;
